import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import { changePassword } from "../../redux/slices/userSlice";
//import ProfileIconActive from "../../assets/icons/sidebar/profileActive.svg";
import { MdPerson } from "react-icons/md";
import {
  Container,
  Wrapper,
} from "../../components/ProfileComponent/PasswordTabStyles";

const PasswordTab = () => {
  const dispatch = useDispatch();
  const { user, loading } = useSelector((state) => state.user);

  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const toggleType = () => {
    setShowPassword(!showPassword);
  };
  const toggleType2 = () => {
    setShowNewPassword(!showNewPassword);
  };
  const toggleType3 = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });

  const handleChange = (e) => {
    setPasswordData({
      ...passwordData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(changePassword(passwordData));
  };

  return (
    <Container>
      <div className="profile">
      <MdPerson className="circled" />
        <div className="texts">
          <h3>
            {user.data?.firstName} {user.data?.lastName}
          </h3>
          <p>{user.data?.userReference}</p>
        </div>
      </div>
      <div className="heading">
        <h2>Password</h2>
        <p>Please enter your current password to change your password.</p>
      </div>
      <form onSubmit={handleSubmit}>
        <Wrapper>
          <label htmlFor="currentPassword">Current Password</label>
          <input
            type={showPassword ? "text" : "password"}
            name="currentPassword"
            placeholder="Current password"
            value={passwordData.currentPassword}
            onChange={handleChange}
            required
          />
          {showPassword ? (
              <FaEyeSlash className="eye" onClick={toggleType} />
            ) : (
              <FaEye className="eye" onClick={toggleType} />
            )}
        </Wrapper>
        <Wrapper>
          <label htmlFor="newPassword">New Password</label>
          <input
            type={showNewPassword ? "text" : "password"}
            name="newPassword"
            placeholder="New password"
            value={passwordData.newPassword}
            onChange={handleChange}
            required
          />
          {showNewPassword ? (
            <FaEyeSlash className="eye" onClick={toggleType2} />
          ) : (
            <FaEye className="eye" onClick={toggleType2} />
          )}
        </Wrapper>
        <Wrapper>
          <label htmlFor="confirmNewPassword">Confirm New Password</label>
          <input
            type={showConfirmPassword ? "text" : "password"}
            name="confirmNewPassword"
            placeholder="Confirm new password"
            value={passwordData.confirmNewPassword}
            onChange={handleChange}
            required
          />
          {showConfirmPassword ? (
            <FaEyeSlash className="eye" onClick={toggleType3} />
          ) : (
            <FaEye className="eye" onClick={toggleType3} />
          )}
        </Wrapper>
        <div className="submit">
          <div></div>
          <div className="submit-buttons">
            <button className="change-password" type="submit" disabled={loading}>
              {loading ? "Updating..." : "Update password"}
            </button>
          </div>
        </div>
      </form>
    </Container>
  );
};

export default PasswordTab;
